<template>
  <section>
    <div class="action-buttons">
      <div class="action-button">
        <button
          v-if="modifiedRows.length"
          class="button field is-green is-medium"
          id="clear"
          @click="validateModifications"
          :disabled="!modifiedRows.length"
        >
          <span>
            <i class="fal fa-check"></i> Valider les modifications
          </span>
        </button>
      </div>
      <div class="action-button">
        <button
          v-if="modifiedRows.length"
          class="button field is-danger is-medium"
          id="clear"
          @click="cancelModifications"
          :disabled="!modifiedRows.length"
        >
          <span>
            <i class="fal fa-times"></i> Annuler les modifications
          </span>
        </button>
      </div>
    </div>

    <b-table
      class="b-table"
      :data="myData"
      :striped="true"
      :hoverable="true"
      :loading="isLoading"
      :mobile-cards="false"
    >
      <template
        slot-scope="props"
        slot="header"
      >
        <b-tooltip
          :active="!!props.column.meta"
          :label="props.column.meta"
        >{{ props.column.label }}</b-tooltip>
      </template>
      <template slot-scope="props">
        <b-table-column
          meta="Nom du Weezy"
          field="weezy_id"
          label="Weezy"
          :centered="true"
          :sortable="true"
          :custom-sort="sortByWeezy"
        >{{ props.row.name }}</b-table-column>

        <b-table-column
          meta="Intervalle de rechargement de l'objectif qotidien"
          field="goal_reload"
          label="Rechargement Objectif Quotidien (s)"
          :centered="true"
          :sortable="true"
        >
          <b-input
            id="goal_reload"
            class="b-input-number"
            type="number"
            min="15"
            oninput="this.value = Math.abs(this.value).toFixed(0)"
            v-model="props.row.goal_reload"
            @input="toggleModified(props.row)"
          ></b-input>
        </b-table-column>

        <b-table-column
          meta="Intervalle de rechargement des utilisateurs"
          field="users_reload"
          label="Rechargement Utilisateurs (s)"
          :centered="true"
          :sortable="true"
        >
          <b-input
            class="b-input-number"
            type="number"
            min="60"
            oninput="this.value = Math.abs(this.value).toFixed(0)"
            v-model="props.row.users_reload"
            @input="toggleModified(props.row)"
          ></b-input>
        </b-table-column>

        <b-table-column
          meta="Intervalle de rechargement de la configuration"
          field="config_reload"
          label="Rechargement Configuration (s)"
          :centered="true"
          :sortable="true"
        >
          <b-input
            class="b-input-number"
            type="number"
            min="60"
            oninput="this.value = Math.abs(this.value).toFixed(0)"
            v-model="props.row.config_reload"
            @input="toggleModified(props.row)"
          ></b-input>
        </b-table-column>

        <!-- <b-table-column
          meta="Nombre de Ventes avant déclenchement du mini-jeu (0 = pas de mini-jeu)"
          field="game_sales_trigger"
          label="Seuil mini-jeu (ventes)"
          :centered="true"
          :sortable="true"
        >
          <b-input
            id="goal_reload"
            class="b-input-number"
            type="number"
            min="0"
            oninput="this.value = Math.abs(this.value).toFixed(0)"
            v-model="props.row.game_sales_trigger"
            @input="toggleModified(props.row)"
          ></b-input>
        </b-table-column> -->

        <b-table-column
          meta="Premier Logo s'affichant lors de l'activation du Weezy"
          field="boot_logo_1"
          label="Boot Logo 1"
          :centered="true"
          width="320"
        >
          <div class="logo-selector-container">
            <b-select
              class="select-logo"
              placeholder="Choisir le logo"
              v-model="props.row.boot_logo_1"
              @input="toggleModified(props.row)"
            >
              <option value="https://api.weezy.soda-armatis.com/static-files/BootLogos/new_soda_white.png">Team SODA</option>
              <option value="https://api.weezy.soda-armatis.com/static-files/BootLogos/orange.png">Orange</option>
              <option value="https://api.weezy.soda-armatis.com/static-files/BootLogos/suez.png">Suez</option>
            </b-select>
            <img
              class="logo"
              :src="props.row.boot_logo_1"
              alt="image"
              height="50px"
              width="50px"
              style="background-color: #000"
            >
          </div>
        </b-table-column>

        <b-table-column
          meta="Deuxième Logo s'affichant lors de l'activation du Weezy"
          field="boot_logo_2"
          label="Boot Logo 2"
          :centered="true"
          width="320"
        >
          <div class="logo-selector-container">

            <b-select
              class="select-logo"
              placeholder="Choisir le logo"
              v-model="props.row.boot_logo_2"
              @input="toggleModified(props.row)"
            >
              <option value="https://api.weezy.soda-armatis.com/static-files/BootLogos/new_soda_white.png">Team SODA</option>
              <option value="https://api.weezy.soda-armatis.com/static-files/BootLogos/orange.png">Orange</option>
              <option value="https://api.weezy.soda-armatis.com/static-files/BootLogos/suez.png">Suez</option>
            </b-select>
            <img
              class="logo"
              :src="props.row.boot_logo_2"
              alt="image"
              height="50px"
              width="50px"
              style="background-color: #000"
            >
          </div>
        </b-table-column>
      </template>

      <template slot="empty">
        <section class="section">
          <div
            v-if="!isLoading"
            class="content has-text-grey has-text-:centered"
          >
            <p>Pas de Weezy à configurer</p>
          </div>
        </section>
      </template>
    </b-table>

    <div
      class="model-button button field is-info is-medium mt4"
      style="display: flex; width: fit-content"
      @click="downloadStripConfig()"
    >
      <span><i class="fa fa-arrow-to-bottom"></i> Télécharger le fichier de configuration des LED Strip</span>
    </div>

    <div
      class="model-button button field is-info is-medium"
      style="display: flex; width: fit-content"
      @click="downloadIDE()"
    >
      <span><i class="fa fa-arrow-to-bottom"></i> Télécharger Arduino IDE</span>
    </div>
  </section>
</template>

<script>
import _ from "lodash";

export default {
  name: "WeezysTable",
  props: ["weezys"],
  data: () => {
    return {
      isLoading: true,
      modifiedRows: [],
      myData: [],
      storedWeezys: [],
    };
  },
  watch: {
    weezys: function (newVal, oldVal) {
      // watch it
      this.myData = this.weezys;
      this.storedWeezys = JSON.parse(JSON.stringify(this.weezys));
      this.isLoading = false;
    },
  },
  methods: {
    downloadIDE() {
      var downloadLink = document.createElement("a");
      downloadLink.href =
        "https://api.weezy.soda-armatis.com/static-files/led_strip/arduino.exe";
      //TODO: Find a way choose the filename of the download
      downloadLink.target = "_blank";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    },

    downloadStripConfig() {
      var downloadLink = document.createElement("a");
      downloadLink.href =
        "https://api.weezy.soda-armatis.com/static-files/led_strip/led_stripv3/led_stripv3.ino";
      //TODO: Find a way choose the filename of the download
      downloadLink.target = "_blank";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    },

    debounceModif: _.debounce(async function (e) {
      this.$parent.modifyRows(e);
    }, 500),

    toggleModified(raaw) {
      this.debounceModif([raaw]);
      // LEFT COMMENTED IF THEY WANT TO RE ADD VALIDATE BUTTON
      // var modified = false;
      // this.modifiedRows.push(raaw);
      // for (var j = 0; j < this.modifiedRows.length; j++) {
      //   var row = this.modifiedRows[j];
      //   for (var i = 0; i < this.storedWeezys.length; i++) {
      //     var weezy = this.storedWeezys[i];
      //     if (weezy.id == row.id) {
      //       console.log("row :", row);
      //       console.log("weezy :", weezy);
      //       if (
      //         !(
      //           weezy.goal_reload == row.goal_reload &&
      //           weezy.users_reload == row.users_reload &&
      //           weezy.config_reload == row.config_reload &&
      //           weezy.boot_logo_1 == row.boot_logo_1 &&
      //           weezy.boot_logo_2 == row.boot_logo_2 &&
      //           weezy.game_sales_trigger == row.game_sales_trigger
      //         )
      //       )
      //         modified = true;
      //     }
      //   }
      // }
      // if (!modified) {
      //   this.modifiedRows = [];
      // }
    },
    // validateModifications() {
    //   console.log(this.modifiedRows);
    //   this.$parent.modifyRows(this.modifiedRows);
    //   setTimeout(() => {
    //     this.modifiedRows = [];
    //   }, 100);
    // },
    // cancelModifications() {
    //   this.$parent.getWeezys();
    //   setTimeout(() => {
    //     this.modifiedRows = [];
    //   }, 100);
    // },
    sortByWeezy(a, b, isAsc) {
      if (isAsc) {
        return b.name.toLowerCase() < a.name.toLowerCase() ? -1 : 1;
      } else {
        return b.name.toLowerCase() > a.name.toLowerCase() ? -1 : 1;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media screen and (max-width: 768px) {
  .action-buttons,
  .action-button {
    float: unset;
  }

  .b-table {
    margin-top: 2em;
  }
}

.b-table {
  width: auto;
}

.b-input-number {
  width: 80px;
  margin-left: 15px;
  text-align: center;
  align-content: center;
  display: inline-block;
}

.has-text-centered {
  vertical-align: inherit;
}

.select-logo {
  height: 50px;
  display: inline;
}

.logo-selector-container {
  align-items: center;
  height: 50px;
  display: flex;
  justify-content: space-evenly;
}

.logo {
  height: 40px;
  width: auto;
  max-width: 75px;
  border-radius: 8px;
}
</style>